import { render, staticRenderFns } from "./ColorMenu.vue?vue&type=template&id=00658d5c&scoped=true&"
import script from "./ColorMenu.vue?vue&type=script&lang=js&"
export * from "./ColorMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00658d5c",
  null
  
)

export default component.exports